import { KYCStatus, KYCStatusMap } from "@/proto/identity/identity/all_pb";

export enum kycApplicationType {
  APPLYING = "applying",
  NOT_APPLYING = "notApplying",
  NOT_APPROVED = "notApproved",
}

export const kycApplicationFilterMap: Record<
  kycApplicationType,
  KYCStatusMap[keyof KYCStatusMap][]
> = {
  [kycApplicationType.APPLYING]: [
    KYCStatus.APPROVE,
    KYCStatus.PENDING,
    KYCStatus.RESUBMISSION,
  ],
  [kycApplicationType.NOT_APPLYING]: [KYCStatus.NOT_APPLYING],
  [kycApplicationType.NOT_APPROVED]: [KYCStatus.NOT_APPROVE],
};

type TKYCApplicationLabel = {
  label: string;
  type: kycApplicationType;
};

export const kycApplicationLabel: Record<
  KYCStatusMap[keyof KYCStatusMap],
  TKYCApplicationLabel
> = {
  [KYCStatus.UNKNOWN_KYCSTATUS]: {
    label: "Not Applying",
    type: kycApplicationType.NOT_APPLYING,
  },
  [KYCStatus.NOT_APPLYING]: {
    label: "Not Applying",
    type: kycApplicationType.NOT_APPLYING,
  },
  [KYCStatus.PENDING]: {
    label: "Applying for Live",
    type: kycApplicationType.APPLYING,
  },
  [KYCStatus.APPROVE]: {
    label: "Approved",
    type: kycApplicationType.APPLYING,
  },
  [KYCStatus.NOT_APPROVE]: {
    label: "Not Approved",
    type: kycApplicationType.NOT_APPROVED,
  },
  [KYCStatus.RESUBMISSION]: {
    label: "Resubmission",
    type: kycApplicationType.APPLYING,
  },
};
